import InternalCheckbox from "./Checkbox";
import Group from "./Group";
var Checkbox = InternalCheckbox;
Checkbox.Group = Group;
export default Checkbox;